import { h } from 'preact';
import SearchIcon from '../../molecules/Icon/Search';
import { getCatalogueTheme } from '../../lib/Theme';
import { activateSearch } from '../../lib/Search';
import './index.less';

const NavBarSearchAction = () => {
  const onSearchClick = () => activateSearch();
  const theme = getCatalogueTheme().homeGrid;

  return (
    <div className={`nav-bar-search-action ${theme.searchClass}`}>
      <div className="search-button" onClick={onSearchClick}>
        <SearchIcon
          color={theme.searchClass === 'dark' ? '#fff' : theme.searchIconColor}
          size={22}
        />
      </div>
    </div>
  );
};

export default NavBarSearchAction;
